'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "httpClient", "onError", "onSuccess", "trimInputValue", "type", "validationMessage", "validateDefaultValue"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import http from 'hub-http/clients/apiClient';
import { propTypes } from '../core/UIValidatedFormControl/UIValidatedFormControlPropsInterface';
import UIValidatedFormControl from '../core/UIValidatedFormControl/UIValidatedFormControl';
import emailValidatorTypes from './emailValidatorTypes';
import emailMessageDefaults from './emailMessageDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
export default class UIValidatedEmailFormControl extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        httpClient = http,
        onError,
        onSuccess,
        trimInputValue = false,
        type = 'apiFast',
        validationMessage = emailMessageDefaults,
        validateDefaultValue = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIValidatedFormControl, Object.assign({}, rest, {
      trimInputValue: trimInputValue,
      validator: "email",
      validationMessage: validationMessage,
      validateDefaultValue: validateDefaultValue,
      validationOpts: {
        type,
        httpClient
      },
      onSuccess: onSuccess,
      onError: onError,
      children: children
    }));
  }
}
UIValidatedEmailFormControl.propTypes = Object.assign({}, propTypes, {
  type: PropTypes.oneOf(emailValidatorTypes),
  httpClient: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
});